.buttons {
  display: flex;
}

.link-disabled {
  color: var(--main-text-disabled);
}

.align-right {
  text-align: right;
}
